import { render } from "./App.vue?vue&type=template&id=0fb19048"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "../src/assets/css/main.css?vue&type=style&index=0&lang=css&external"
import "../src/assets/css/main.less?vue&type=style&index=1&lang=less&external"
import "vue3-carousel-3d/dist/index.css?vue&type=style&index=2&lang=css&external"
import "../src/assets/css/views/shared.css?vue&type=style&index=3&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__